import "@core/extensions";
import { lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import FlexBox from "./components/FlexBox";
import FuzionLoader from "./components/FuzionLoader";
import AppContextProvider, { useAppSettings } from "./providers/AppContextProvider";
import ThemeProvider from "./providers/AppThemeProvider";
import AuthContextProvider from "./providers/AuthContextProvider";
import NotificationProvider from "./providers/NotificationProvider";

const FeatureDisabled = lazy(() => import("./components/FeatureDisabled"));   
const TeamsAppAuthentication = lazy(() => import("./views/Authentication").then(module => ({ default: module.TeamsAppAuthentication })));
const TeamsAppView = lazy(() => import("./views/TeamsAppView"));

createRoot(document.getElementById("root")!).render(<App />);

function App() {
    return <ThemeProvider>
        <FlexBox sx={{ bgcolor: "#282c34", color: "text.primary", height: "100vh", overflow: "hidden" }}>
            <AppContextProvider>
                <NotificationProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route index element={<FuzionLoader sx={{ m: "auto" }} />} />
                            <Route path="teams-app/*" element={<TeamsApp />} />
                            <Route path="*" element={<div>Express Client App - 404 Not Found</div>} />
                        </Routes>
                    </BrowserRouter>
                </NotificationProvider>
            </AppContextProvider>
        </FlexBox>
    </ThemeProvider>;
}

function TeamsApp() {
    const settings = useAppSettings();

    return settings.Features.includes("TeamsApp") ? (
        <Routes>
            <Route path="login_success" element={<TeamsAppAuthentication />} />
            <Route path="login_failure" element={<TeamsAppAuthentication failed />} />
            <Route path="*" index element={<AuthContextProvider>
                <TeamsAppView />
            </AuthContextProvider>} />
        </Routes>
    ) : <FeatureDisabled name="Teams App" />;
}